import { forwardRef } from "react";
import { SxProps, Theme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface ICustomIcon extends Omit<SvgIconProps, "children"> {
    icon: JSX.Element;
    sx?: SxProps<Theme>;
}

const CustomIcon = forwardRef(function CustomIcon(
    { icon, ...otherProps }: ICustomIcon,
    ref: ((instance: SVGSVGElement | null) => void) | React.RefObject<SVGSVGElement> | null | undefined
) {
    return (
        <SvgIcon component="svg" {...otherProps} ref={ref}>
            <g fill="currentColor">{icon}</g>
        </SvgIcon>
    );
});

export default CustomIcon;
